<div class="section-footer">
  <div class="card-button">
        <ng-container *ngIf="!enabledIcons">
          <ng-container
            *ngFor="let item of checkboxIcon; let i=index"
            id="item.id" 
          >
            <mat-icon 
              (click)="sendData()" 
              *ngIf="item.icon"
            >
                {{item.icon}}
            </mat-icon>
            <mat-icon 
              (click)="sendData()" 
              *ngIf="item.iconSVG" 
              class="iconSVG-footer" 
              [svgIcon]="item.iconSVG"
              >
            </mat-icon>
            </ng-container>
        </ng-container>
        <mat-checkbox #checkbox (change)="changeTotalSelection(checkbox.checked)"></mat-checkbox>
  </div>
</div>
